import React, { useState, useContext, useEffect } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import ExportCsv from "@material-table/exporters/csv";
import ExportPdf from "@material-table/exporters/pdf";

export default function ExportFileNameDialog(props) {
  const {
    openExportDialog,
    setOpenExportDialog,
    csvFileNameTest,
    setCsvFileNameTest,
    exportCols,
    exportData,
  } = props;
  const handleClose = () => {
    setOpenExportDialog(false);
  };

  const handleTextFieldChange = (e) => {
    setCsvFileNameTest(e.target.value);
  };

  const handleDownloadPDF = () => {
    setOpenExportDialog(false);
    ExportPdf(exportCols, exportData, csvFileNameTest);
  };

  const handleDownloadCSV = () => {
    setOpenExportDialog(false);
    ExportCsv(exportCols, exportData, csvFileNameTest);
  };

  function fetchExportButtonColor() {
    if (
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches
    ) {
      // dark mode
      return "secondary";
    } else {
      return "primary";
    }
  }
  const exportButtonColor = fetchExportButtonColor();

  return (
    <div>
      <Dialog
        open={openExportDialog}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Download</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please enter the filename here (no file extension, i.e. csv).
          </DialogContentText>
          <DialogContentText>
            The file will be saved in user's downloads folder.
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Filename:"
            fullWidth
            onChange={handleTextFieldChange}
            variant="filled"
            defaultValue={csvFileNameTest}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color={exportButtonColor}>
            Cancel
          </Button>
          <Button onClick={handleDownloadPDF} color={exportButtonColor}>
            Download PDF
          </Button>
          <Button onClick={handleDownloadCSV} color={exportButtonColor}>
            Download CSV
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
